class SecureStorage {
  constructor() {
    this.memory = new Map();
    this.isStorageAvailable = this.checkStorageAvailability();
  }

  checkStorageAvailability() {
    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
      return true;
    } catch (e) {
      console.warn('Storage check failed:', e);
      return false;
    }
  }

  setItem(key, value) {
    try {
      if (this.isStorageAvailable) {
        localStorage.setItem(key, value);
      } else {
        this.memory.set(key, value);
      }
    } catch (e) {
      console.warn('Storage write failed, using memory fallback:', e);
      this.memory.set(key, value);
      // Optionally, rethrow if you want the caller to handle it further
      // throw e;
    }
  }

  getItem(key) {
    try {
      if (this.isStorageAvailable) {
        return localStorage.getItem(key);
      }
      return this.memory.get(key) || null;
    } catch (e) {
      console.warn('Storage read failed, using memory fallback:', e);
      return this.memory.get(key) || null;
    }
  }
}

const secureStorage = new SecureStorage();
window.cartStorage = secureStorage;
